import React from 'react'
import { fetchLinkedOpportunityAnalysisCounts } from '../services/analysisLinkedOpportunityService'

type UseLinkedOpportunityAnalysisCountsResult = {
  map: Record<number, number>
  loading: boolean
  error: string | null
}

export function useLinkedOpportunityAnalysisCounts(
  opportunityIds: number[],
  excludeAnalysisId: number | null,
  enabled: boolean,
): UseLinkedOpportunityAnalysisCountsResult {
  const [map, setMap] = React.useState<Record<number, number>>({})
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const normalizedIds = React.useMemo(() => {
    const ids = (opportunityIds || [])
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id) && id > 0)
      .sort((a, b) => a - b)
    return Array.from(new Set(ids))
  }, [opportunityIds])

  React.useEffect(() => {
    if (!enabled) {
      setMap({})
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    fetchLinkedOpportunityAnalysisCounts({
      opportunityIds: normalizedIds,
      excludeAnalysisId,
    })
      .then((next) => {
        if (!active) return
        setMap(next || {})
      })
      .catch((e: any) => {
        if (!active) return
        setMap({})
        setError(e?.message || 'Falha ao verificar analises existentes')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, excludeAnalysisId, normalizedIds])

  return { map, loading, error }
}
